import React, { useState } from 'react';
import { Button } from '../../../components/ui/button';
import { Checkbox } from '../../../components/ui/checkbox';
import { Loader2, MailOpen, Mail } from 'lucide-react';

export const CRMBulkBar = ({ etiquetas, equipo = [], total, seleccionados, onToggleTodos, onAplicar }) => {
  const [etiqueta, setEtiqueta] = useState('');
  const [busy, setBusy] = useState(false);
  const n = seleccionados.length;
  const run = async (payload) => { setBusy(true); await onAplicar(payload); setBusy(false); };
  return (
    <div className="p-2 border-b bg-emerald-50 space-y-2" data-testid="crm-bulk-bar">
      <div className="flex items-center gap-2 text-xs">
        <Checkbox checked={total > 0 && n === total} onCheckedChange={onToggleTodos} data-testid="crm-check-todos" />
        <span className="font-medium" data-testid="crm-bulk-count">{n} seleccionado{n !== 1 ? 's' : ''}</span>
      </div>
      <div className="flex items-center gap-1.5 flex-wrap">
        <select className="border rounded-md px-2 py-1 text-xs bg-white flex-1 min-w-[110px]" value={etiqueta}
          onChange={e => setEtiqueta(e.target.value)} data-testid="crm-bulk-etiqueta">
          <option value="">Cambiar estado…</option>
          {etiquetas.map(e => <option key={e.id} value={e.id}>{e.label}</option>)}
        </select>
        <Button size="sm" className="h-7 text-xs" disabled={!n || !etiqueta || busy}
          onClick={() => run({ etiqueta })} data-testid="crm-bulk-aplicar">
          {busy ? <Loader2 className="w-3 h-3 animate-spin" /> : 'Aplicar'}
        </Button>
        <Button size="sm" variant="outline" className="h-7 px-2" disabled={!n || busy} title="Marcar como leídos"
          onClick={() => run({ leido: true })} data-testid="crm-bulk-leido"><MailOpen className="w-3.5 h-3.5" /></Button>
        <Button size="sm" variant="outline" className="h-7 px-2" disabled={!n || busy} title="Marcar como no leídos"
          onClick={() => run({ leido: false })} data-testid="crm-bulk-no-leido"><Mail className="w-3.5 h-3.5" /></Button>
      </div>
      <select className="w-full border rounded-md px-2 py-1 text-xs bg-white" value="" disabled={!n || busy}
        onChange={e => e.target.value && run({ responsable: e.target.value === '__none' ? '' : e.target.value })}
        data-testid="crm-bulk-responsable">
        <option value="">Asignar a…</option>
        <option value="__none">Sin responsable</option>
        {equipo.map(u => <option key={u.id} value={u.id}>{u.nombre}</option>)}
      </select>
    </div>
  );
};
